/*
 *   File : sales-history.js
 *   Author : https://evoqins.com
 *   Description :Sales history data modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import { memo } from 'react'

// Custom components
import { Icon } from '../Icon';
import { DataTableComponent } from '../DataTable';
import { useSelector } from 'react-redux';

const SalesHistoryModal = (props) => {

    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);


    const data = props.data;
    const SALES_HISTORY_COLUMNS = [
        {
            name: 'Product name',
            selector: row => row.product_name || '-',
            wrap: true,
        },
        {
            name: 'Product code',
            selector: row => row.product_code || '-',
            width: '120px',
        },
        {
            name: PROFILE_DATA.country === "Egypt" ? 'Units sold' : 'Ltrs sold',
            selector: row => row.quantity ?? '-',
            width: '100px',
        },
    ];

    return (
        <div className="modal fade"
            id="sale-history-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SalesHistoryModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-border-radius-12 ">
                    <div className="modal-header px-4 pt-3 padding-26px-bottom border-0 align-items-start">
                        <h4 className='e-text-dark-jungle-green e-primary-font-playfair e-font-18 e-font-weight-500 line-height-28px mb-0'>
                            Sale history
                        </h4>
                        <Icon icon="close-icon"
                            data-bs-dismiss={"modal"}
                            className='cursor-pointer'
                            size="24px"
                            onPress={props.handleClose} />

                    </div>
                    <div className="modal-body p-0 e-scroll ">
                        <div className='e-table no-strip no-hover'>
                            <DataTableComponent columns={SALES_HISTORY_COLUMNS}
                                data={data}
                                fixedHeader
                                fixedHeaderScrollHeight="80vh"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

SalesHistoryModal.defaultProps = {
    handleClose: () => { }
}


export default memo(SalesHistoryModal);